export default "__VITE_ASSET__BeUNn$3e__"